<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("screencollectionreport") }}</div>
      <div class="mt-3 border-bottom">
        <div class="row">
          <!-- START DATE -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getScreenCollectionReportFromDate"
                  v-on:click="
                    onScreenCollectionReportDateHandler({
                      event: null,
                      name: 'fromDate',
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onScreenCollectionReportDateHandler({
                      event: $event,
                      name: 'fromDate',
                    })
                  "
                  ref="programaticOpen"
                  :value="getScreenCollectionReportFromDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label
                  :class="getScreenCollectionReportFromDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("date") }}</label
                >
              </div>
            </div>
          </div>

          <!-- END DATE -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getScreenCollectionReportFromDate"
                  v-on:click="
                    onScreenCollectionReportDateHandler({
                      event: null,
                      name: 'toDate',
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onScreenCollectionReportDateHandler({
                      event: $event,
                      name: 'toDate',
                    })
                  "
                  ref="programaticOpen"
                  :value="getScreenCollectionReportToDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getScreenCollectionReportToDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("date") }}</label
                >
              </div>
            </div>
          </div>
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getScreenCollectionReportSelectedCinema &&
                  getScreenCollectionReportSelectedCinema.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :text="getScreenCollectionReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onScreenCollectionReportDropdownHandler({
                      event: $event,
                      name: 'Cinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                    getScreenList(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getScreenCollectionReportSelectedScreen ? 'shift-up' : ''
                "
                >{{ $tc("Screen", 1) }}</label
              >
              <b-dropdown
                :text="getScreenCollectionReportSelectedScreenName"
                variant="dropdown-curve"
                class="w-100"
                :disabled="isRoleID"
              >
                <!-- <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div> -->
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Screens"
                  :key="dropdownIndex"
                  @click="
                    onScreenCollectionReportDropdownHandler({
                      event: $event,
                      name: 'ScreenID',
                      selectedItem: dropdownItem,
                      index: dropdownIndex,
                    })
                  "
                  >{{ dropdownItem.screen_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <button
              class="btn-blue-lg w-100"
              @click.prevent.stop="fetchScreenCollectionReportListv2"
            >
              {{ $t("fetch") }} {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="getScreenCollectionReportList.length > 0"
            class="col-lg-4 col-xl-9 align-self-center mb-4 d-flex justify-content-end align-items-center"
          >
            <div>{{ $t("download") }} as:</div>
            <a
              v-if="getScreenCollectionPDFFileName"
              :href="BASE_URL + getScreenCollectionPDFFileName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              v-if="getScreenCollectionExcelFileName"
              :href="BASE_URL + getScreenCollectionExcelFileName"
              target="_blank"
              download
              title="Download as Excel"
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
        </div>
      </div>

      <div class="swc-report">
        <div class="table-scroll">
          <table class="swc-report-table" border="1">
            <thead>
              <tr class="bg-lightgrey">
                <th>{{ $t("Show Date") }}</th>
                <th>{{ $tc("screen", 1) }}</th>
                <th>{{ $t("film") }}</th>
                <th>{{ $t("show") }} No</th>
                <th>{{ $t("show") }} {{ $t("time") }}</th>
                <th>{{ $t("class") }}</th>
                <th>{{ $tc("ticket", 1) }} {{ $tc("category", 1) }}</th>
                <th>{{ $tc("ticket", 1) }} {{ $tc("type", 1) }}</th>
                <th>{{ $t("sold") }}</th>
                <th>{{ $t("rate") }}</th>
                <th>{{ $t("amount") }}</th>
                <th>{{ $t("discount") }}</th>
              </tr>
            </thead>
            <tbody v-if="getScreenCollectionReportList.length === 0">
              <tr>
                <td colspan="11">
                  <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
                </td>
              </tr>
            </tbody>
            <template v-if="getScreenCollectionReportList.length > 0">
              <tbody
                v-for="(GetScreenCollectionReportList,
                indexGetScreenCollectionReportList) in getScreenCollectionReportList"
                :key="indexGetScreenCollectionReportList"
              >
                <tr
                  v-for="(Screens,
                  ScreensIndex) in GetScreenCollectionReportList.screens"
                  :key="ScreensIndex"
                >
                  <!-- <td>{{ Screens.group.length > 0 ? Screens.group[0].screen_name : '' }}</td>
            <td>Avengers: End Game</td>
            <td>1</td>
            <td class="text-nowrap">11:30 AM</td>
            <td>Class</td>
            <td>General</td>
            <td>1</td>
            <td>30.00</td>
                <td>Amount</td>-->
                  <td style="text-align:left;">{{ Screens.t_show_date }}</td>
                  <td style="text-align:left;">{{ Screens.screen_name }}</td>
                  <td style="text-align:left;">{{ Screens.movie_name }}</td>
                  <td style="text-align:right;">
                    {{ Screens.schedule_show_id }}
                  </td>
                  <td class="text-nowrap" style="text-align:right;">
                    {{ Screens.t_show_time }}
                  </td>
                  <td style="text-align:left;">{{ Screens.seat_type_name }}</td>
                  <td style="text-align:left;">{{ Screens.shift_name }}</td>
                  <td style="text-align:left;">
                    {{ Screens.ticket_type_name }}
                  </td>
                  <td style="text-align:right;">{{ Screens.SoldNo }}</td>
                  <td style="text-align:right;">
                    {{ currFormat(Screens.rate) }}
                  </td>
                  <td style="text-align:right;">
                    {{ currFormat(Screens.Amount) }}
                  </td>
                  <td style="text-align:right;">
                    {{ currFormat(Screens.discount) }}
                  </td>
                </tr>

                <tr class="bg-lightgrey">
                  <td colspan="7" class="py-1">
                    <strong
                      >{{ $t("total") }}
                      {{
                        GetScreenCollectionReportList.screens.length > 0
                          ? `of ${GetScreenCollectionReportList.screens[0].screen_name}`
                          : ""
                      }}</strong
                    >
                  </td>
                  <td style="text-align:right">
                    <strong>{{
                      GetScreenCollectionReportList.screens.reduce(function(
                        accumulator,
                        { SoldNo }
                      ) {
                        return accumulator + parseFloat(SoldNo);
                      },
                      0)
                    }}</strong>
                  </td>
                  <td class="py-1" style="text-align:right"></td>
                  <td class="py-1" style="text-align:right">
                    <strong>{{
                      currFormat(
                        GetScreenCollectionReportList.screens.reduce(function(
                          accumulator,
                          { Amount }
                        ) {
                          return accumulator + parseFloat(Amount);
                        },
                        0)
                      )
                    }}</strong>
                  </td>
                  <td class="py-1" style="text-align:right">
                    <strong>{{
                      currFormat(
                        GetScreenCollectionReportList.screens.reduce(function(
                          accumulator,
                          { discount }
                        ) {
                          return accumulator + parseFloat(discount);
                        },
                        0)
                      )
                    }}</strong>
                  </td>
                </tr>

                <!-- <tr>
            <td>Screen 2</td>
            <td>ANGEL HAS FALLEN</td>
            <td>1</td>
            <td>11:30 AM</td>
            <td>Class</td>
            <td>Ticket Category</td>
            <td>1</td>
            <td>30.00</td>
            <td>Amount</td>
          </tr>
          
          <tr class="bg-lightgrey">
            <td colspan="6" class="py-1">
              <strong>Total of SCREEN 1</strong>
            </td>
            <td>
              <strong>27</strong>
            </td>
            <td class="py-1"></td>
            <td class="py-1">
              <strong>915.00</strong>
            </td>
              </tr>-->
              </tbody>
              <tbody>
                <tr class="bg-lightgrey">
                  <td colspan="7" class="py-1">
                    <strong>{{ $t("total") }}</strong>
                  </td>
                  <td style="text-align:right">
                    <strong>{{ getScreenGrandTotal.totalSold }}</strong>
                  </td>
                  <td class="py-1" style="text-align:right"></td>
                  <td class="py-1" style="text-align:right">
                    <strong>{{
                      currFormat(getScreenGrandTotal.totalAmount)
                    }}</strong>
                  </td>
                  <td class="py-1" style="text-align:right">
                    <strong>{{
                      currFormat(getScreenGrandTotal.totalDiscount)
                    }}</strong>
                  </td>
                </tr>
              </tbody>
            </template>
          </table>
        </div>
        <!-- {{ getScreenGrandTotal }} -->
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from "vuex";
  import MasterService from "@/services/MasterService";

  export default {
    data() {
      return {
        Cinemas: [],
        Screens: [],
        isRoleID: true,
        CinemasCopy: [],
        searchCinema: "",
      };
    },
    computed: {
      ...mapGetters([
        // Flags
        "getScreenCollectionReportsIsCinema",
        // End
        "getScreenCollectionReportList",
        "getScreenCollectionReportToDate",
        "getScreenCollectionReportFromDate",
        "getCinemasList",
        "getScreenCollectionReportSelectedCinema",
        "getScreenCollectionReportSelectedScreen",
        "getScreenCollectionReportSelectedScreenName",

        // EXCEL
        "getScreenCollectionExcelFileName",
        // PDF
        "getScreenCollectionPDFFileName",
        // GET GRAND TOTAL
        "getScreenGrandTotal",
      ]),
    },
    beforeMount() {
      // console.log("screenCollectionReportsList :", screenCollectionReportsList);
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      let cinemaId = null;
      this.getCinemaList(cinemaId);

      // this.onScreenCollectionReportFlagHandler({
      //   event: null,
      //   name: "isCinema",
      //   value: cinemaId
      // });
      this.onScreenCollectionReportFlagHandler({
        event: null,
        name: "isCountry",
        value: this.secureStore.get("BRGLOPCO") || null,
      });

      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.onScreenCollectionReportDropdownHandler({
          event: null,
          name: "Cinema",
          selectedItem: CinemaObj,
        });
      }
      // this.fetchCinemasList({ cinemaId });
    },
    watch: {
      "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
        if (CinemaObj) {
          this.onScreenCollectionReportDropdownHandler({
            event: null,
            name: "Cinema",
            selectedItem: CinemaObj,
          });
        }
      },
    },
    mounted() {},
    methods: {
      onSelectCinema(cinema) {
        this.$store.dispatch("selectDropdownCinema", cinema);
      },
      getScreenList: function(dropdownItem) {
        this.Screens = [];
        let payload = {
          tableName: "screens",
          screen_is_active: "Y",
          cinema_id: dropdownItem.cine_id,
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Screens = data.Records;
            } else {
              // Show Errors
              console.log("show error :", data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            console.log("show error :", error);
          });
      },
      onSearchCinema: function() {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      getCinemaList: function(cine_id) {
        this.Cinemas = [];
        //  let payload = null
        //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              // this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // let cinema = {
                  //   cine_name: x.cine_name,
                  //   cine_id: x.cine_id
                  // };

                  // this.onSelectCinema(null,cinema);
                  this.onScreenCollectionReportFlagHandler({
                    event: null,
                    name: "isCinema",
                    value: x.cine_id,
                    cine_name: x.cine_name,
                  });
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      ...mapActions([
        "fetchCinemasList",

        "fetchScreenCollectionReportListv2",
        "onScreenCollectionReportDateHandler",
        "onScreenCollectionReportDropdownHandler",
        "onScreenCollectionReportFlagHandler",
        // RESET STORE
        "onResetScreenCollectionReportStoreState",
      ]),
    },
    beforeDestroy: async function() {
      await this.$store.dispatch("globalRemoveFile", {
        fileName: this.getScreenCollectionExcelFileName,
      });
      await this.$store.dispatch("globalRemoveFile", {
        fileName: this.getScreenCollectionPDFFileName,
      });
      await this.onResetScreenCollectionReportStoreState();
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/screenWiseCollectionReport-v2.vue